import React from "react";

const TermsOfService = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Terms of Service</h1>

      <p style={styles.paragraph}>
        This website (“Site”) and platform (“Platform”) is operated by{" "}
        <strong>Funde Technologies</strong>. It is available at{" "}
        <strong>www.headwayspot.com</strong> and may be available through other
        addresses, subdomains, or channels.
      </p>

      <h2 style={styles.subheading}>Terms of Use</h2>
      <p style={styles.paragraph}>
        Please read these Terms of Service (“User Terms”) carefully, as they
        contain information about your legal rights, remedies, and obligations.
        By accessing or using the Headway Spot Site or Platform (the “Services”),
        these User Terms apply to you.
      </p>

      <p style={styles.paragraph}>
        These User Terms are a legally binding contract between you and us. If
        you access or use the Services, or continue accessing or using the
        Services after being notified of a change to the User Terms or the
        Privacy Policy, you confirm that you have read, understand, and agree to
        be bound by these User Terms and the Privacy Policy.
      </p>

      <p style={styles.paragraph}>
        “We”, “our”, and “us” refers to <strong>Funde Technologies</strong>.
        <br />
        “You”, and “yours” refers to an <strong>Authorized User</strong>.
      </p>

      <h2 style={styles.subheading}>Authorized Users</h2>
      <p style={styles.paragraph}>
        An organization or other third party (the “Client”) has invited you to
        use the Services. For example, if you have been invited by your employer,
        the Client is your employer.
      </p>

      <p style={styles.paragraph}>
        The Client has entered into a separate written agreement with us (the
        “Contract”) which permits the Client to configure and offer the Services
        to you and others (each an “Authorized User”). If you are both the Client
        and an Authorized User, then both the Contract and these User Terms apply
        to you.
      </p>

      <h2 style={styles.subheading}>Client Data & Ownership</h2>
      <p style={styles.paragraph}>
        When an Authorized User submits text or other information to the
        Services (“Client Data”), you acknowledge and agree that:
      </p>

      <ul style={styles.list}>
        <li>The Client Data is owned by the Client</li>
        <li>
          The Client permits Funde Technologies to use, modify, and aggregate
          Client Data solely to provide the Services
        </li>
        <li>
          Funde Technologies owns all derived Aggregated Information
        </li>
        <li>
          Aggregated Information does not identify any specific user or Client
        </li>
      </ul>

      <h2 style={styles.subheading}>
        Relationship Between You, the Client, and Us
      </h2>
      <p style={styles.paragraph}>
        As between us and the Client, you agree that it is solely the Client’s
        responsibility to:
      </p>

      <ul style={styles.list}>
        <li>Inform you of policies, practices, and configurations</li>
        <li>Obtain all rights and permissions for Client Data</li>
        <li>Ensure lawful transfer and processing of Client Data</li>
        <li>
          Respond to disputes with you regarding Client Data or the Services
        </li>
      </ul>

      <h2 style={styles.subheading}>Disclaimer</h2>
      <p style={styles.paragraph}>
        ALL SERVICES ARE PROVIDED “AS IS” AND FUNDE TECHNOLOGIES DISCLAIMS ALL
        WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE,
        NON-INFRINGEMENT, AND ANY WARRANTIES ARISING FROM COURSE OF DEALING OR
        USAGE.
      </p>

      <p style={styles.paragraph}>
        We do not guarantee that the Services will meet your requirements, be
        uninterrupted, error-free, secure, accurate, or compatible with
        third-party systems.
      </p>

      <p style={styles.paragraph}>
        ALL THIRD-PARTY MATERIALS ARE PROVIDED “AS IS” AND ANY WARRANTIES RELATED
        TO THEM ARE BETWEEN YOU OR THE CLIENT AND THE THIRD PARTY.
      </p>

      <h2 style={styles.subheading}>The Basics</h2>
      <p style={styles.paragraph}>
        All Authorized Users must agree to our Privacy Policy available at{" "}
        <strong>https://www.headwayspot.com/privacy-policy</strong>.
      </p>

      <p style={styles.paragraph}>
        Your access continues until the Client’s Contract expires, the Client
        terminates your access, or we terminate your access. You may stop using
        the Services at any time.
      </p>

      <h2 style={styles.subheading}>Limitation of Liability</h2>
      <p style={styles.paragraph}>
        To the maximum extent permitted by law, you agree that your use of the
        Services is at your own risk. Neither you nor Funde Technologies shall
        be liable for any indirect, special, punitive, or consequential damages,
        whether in contract or tort, even if advised of the possibility.
      </p>

      <h2 style={styles.subheading}>Termination</h2>
      <p style={styles.paragraph}>
        We may terminate these Terms at any time without notice. Upon
        termination, all liability limitations and applicable obligations
        survive.
      </p>

      <h2 style={styles.subheading}>Revisions to Terms</h2>
      <p style={styles.paragraph}>
        We may update these Terms at any time by publishing revised Terms on
        headwayspot.com. Continued use constitutes acceptance.
      </p>

      <h2 style={styles.subheading}>General Provisions</h2>

      <h3 style={styles.minorHeading}>Content You Upload</h3>
      <p style={styles.paragraph}>
        You are solely responsible for all content you upload. You represent
        that you own or have rights to the content, it does not violate laws,
        and it does not contain PII belonging to a Client. We may remove content
        at our discretion.
      </p>

      <h3 style={styles.minorHeading}>Ownership of Data & Copyright</h3>
      <p style={styles.paragraph}>
        Funde Technologies owns all Aggregated Information and may use, publish,
        disclose, or sell it. We do not claim ownership over Client Data.
      </p>

      <h3 style={styles.minorHeading}>Restrictions on Use</h3>
      <ul style={styles.list}>
        <li>Reverse-engineer the Services</li>
        <li>Share credentials</li>
        <li>Build competing products</li>
        <li>Copy features or tamper with security</li>
        <li>Publish evaluations without consent</li>
      </ul>

      <p style={styles.paragraph}>
        Competitors of Funde Technologies are prohibited from using the Site or
        Platform.
      </p>

      <h3 style={styles.minorHeading}>Service Discontinuation</h3>
      <p style={styles.paragraph}>
        We may discontinue the Site or Platform at any time without notice and
        are not liable for resulting losses.
      </p>

      <h2 style={styles.subheading}>Governing Law</h2>
      <p style={styles.paragraph}>
        These Terms are governed by Indian law. Disputes must be filed
        exclusively in courts located in Mumbai, Maharashtra.
      </p>

      <h2 style={styles.subheading}>Company Information</h2>
      <p style={styles.paragraph}>
        <strong>Funde Technologies</strong>
        <br />
        Plot number 2/5, Bhagwan Nagar, Pathardi,
        <br />
        Dist. – AhilyaNagar, 414102, Maharashtra, India
      </p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "40px 20px",
    lineHeight: "1.7",
    color: "#1f2937",
  },
  heading: {
    fontSize: "32px",
    fontWeight: "700",
    marginBottom: "24px",
  },
  subheading: {
    fontSize: "20px",
    fontWeight: "600",
    marginTop: "28px",
    marginBottom: "12px",
  },
  minorHeading: {
    fontSize: "17px",
    fontWeight: "600",
    marginTop: "18px",
    marginBottom: "8px",
  },
  paragraph: {
    fontSize: "16px",
    marginBottom: "14px",
  },
  list: {
    paddingLeft: "20px",
    marginBottom: "16px",
  },
};

export default TermsOfService;